@if (!loading) {
<div class="view-container">
  <div class="toolbar row">
    <div class="toolbar-left row">
      @if (showSelectAll) {
      <div class="toolbar-item row clickable" (click)="changeSelectAll()">
        <input
          class="checkbox"
          type="checkbox"
          [ngModel]="isChildrenAllSelected()"
        />
        SELECT ALL
      </div>
      }
    </div>
    <div class="toolbar-right row">
      @if (showSortBy) {
      <div class="toolbar-sort row">
        <div class="sort-title">SORT BY</div>
        <div class="sort-tool row">
          @if (sortBy==='type') {
          <div class="sort-by clickable row" (click)="changeSortBy('update')">
            File Type
          </div>
          } @if (sortBy==='update') {
          <div class="sort-by clickable row" (click)="changeSortBy('type')">
            Last Update
          </div>
          }
          <div class="sort-order">
            @if (sortOrder==='desc') {
            <img
              class="sort-icon inactive clickable"
              (click)="changeSortOrder('asc')"
              src="assets/rubix-documents/keyboard_arrow_up_black_24dp.svg"
              alt="arrow-up"
            />
            } @if (sortOrder==='desc') {
            <img
              class="sort-icon active clickable"
              (click)="changeSortOrder('desc')"
              src="assets/rubix-documents/keyboard_arrow_down_black_24dp.svg"
              alt="arrow-up"
            />
            } @if (sortOrder==='asc') {
            <img
              class="sort-icon active clickable"
              (click)="changeSortOrder('asc')"
              src="assets/rubix-documents/keyboard_arrow_up_black_24dp.svg"
              alt="arrow-up"
            />
            } @if (sortOrder==='asc') {
            <img
              class="sort-icon inactive clickable"
              (click)="changeSortOrder('desc')"
              src="assets/rubix-documents/keyboard_arrow_down_black_24dp.svg"
              alt="arrow-up"
            />
            }
          </div>
        </div>
      </div>
      } @if (showLayout) {
      <div class="toolbar-layout row">
        @if (layout==='list') {
        <img
          class="view-icon inactive clickable"
          (click)="changeLayout('grid')"
          src="assets/rubix-documents/grid_view_black_24dp.svg"
          alt="grid-view"
        />
        } @if (layout==='list') {
        <img
          class="view-icon active clickable"
          (click)="changeLayout('list')"
          src="assets/rubix-documents/format_list_bulleted_black_24dp.svg"
          alt="list-view"
        />
        } @if (layout==='grid') {
        <img
          class="view-icon active clickable"
          (click)="changeLayout('grid')"
          src="assets/rubix-documents/grid_view_black_24dp.svg"
          alt="grid-view"
        />
        } @if (layout==='grid') {
        <img
          class="view-icon inactive clickable"
          (click)="changeLayout('list')"
          src="assets/rubix-documents/format_list_bulleted_black_24dp.svg"
          alt="list-view"
        />
        }
      </div>
      }
    </div>
  </div>
  @if (layout==='grid') {
  <app-grid-view></app-grid-view>
  } @if (layout==='list') {
  <app-list-view></app-list-view>
  }
  <div class="footer-buttons">
    @if (showNewFolder) {
    <div class="ui button primary">
      <div class="button-name" (click)="openCreateFolderModal()">
        New folder
        <img
          class="button-icon"
          src="assets/rubix-documents/create_new_folder_white_24dp.svg"
          alt="new_folder"
        />
      </div>
    </div>
    }
    <input
      #fileUpload
      type="file"
      class="hidden"
      (change)="initFile($event.target['files'])"
    />
    @if (showUploadDocument) {
    <div class="ui primary button">
      <div class="button-name" (click)="fileUpload.click()">
        Upload document
        <img
          class="button-icon"
          src="assets/rubix-documents/file_upload_white_24dp.svg"
          alt="upload"
        />
      </div>
    </div>
    }
    <div
      (click)="downloadSelected()"
      class="ui primary button"
      [ngClass]="{ loading: isDownloadPending, disabled: isDownloadDisabled() }"
    >
      <div class="button-name">
        Download selected
        <img
          class="button-icon"
          src="assets/rubix-documents/file_download_white_24dp.svg"
          alt="upload"
        />
      </div>
    </div>
  </div>
</div>
} @if (loading) {
<div class="view-container loading">
  <div class="ui active centered inline loader"></div>
</div>
}

<div #newFolderModal class="ui tiny modal new-folder-modal">
  <div class="modal-close close icon"></div>

  <h1>Create New Folder</h1>

  <form (ngSubmit)="saveNewFolder()">
    <div class="content">
      <label>Folder Name</label>
      <input
        [ngModelOptions]="{ standalone: true }"
        type="text"
        [(ngModel)]="newFolderName"
      />
    </div>

    <div class="actions">
      <span class="go-back cancel">Cancel</span>
      <button
        class="ui primary background button"
        [ngClass]="{ disabled: !newFolderName }"
      >
        Create
      </button>
    </div>
  </form>
</div>
